import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageHero } from "./About";
import { SectionHeader } from "../components/UI";
import { Check, ArrowRight } from "lucide-react";

export default function ForManufacturers() {
  const { t } = useTranslation();
  const benefits = t("manufacturers_page.benefits", { returnObjects: true });
  const process = t("manufacturers_page.process", { returnObjects: true });
  return (
    <div data-testid="page-manufacturers">
      <PageHero eyebrow="For Manufacturers" title={t("manufacturers_page.hero_title")} subtitle={t("manufacturers_page.hero_subtitle")} image="https://images.pexels.com/photos/19233057/pexels-photo-19233057.jpeg"/>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-16">
          <div>
            <SectionHeader eyebrow="Benefits" title={t("manufacturers_page.benefits_title")} />
            <ul className="mt-10 space-y-4">
              {benefits.map((b,i) => (
                <li key={i} className="flex items-start gap-3">
                  <Check size={18} className="text-[#00E5FF] mt-1 shrink-0" strokeWidth={2}/>
                  <span className="text-[#0B1120] text-base">{b}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <SectionHeader eyebrow="Process" title={t("manufacturers_page.process_title")} />
            <ol className="mt-10 space-y-4">
              {process.map((p,i) => (
                <li key={i} className="flex items-start gap-4 border-b border-slate-200 pb-4">
                  <span className="font-display font-bold text-[#003399] text-2xl w-8">{String(i+1).padStart(2,'0')}</span>
                  <span className="text-[#0B1120] pt-1">{p}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>
      <section className="py-24 md:py-32 bg-[#F5F7FB]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <SectionHeader eyebrow="Commercial Model" title={t("manufacturers_page.model_title")} />
          <p className="mt-8 text-lg text-[#4A5568] leading-relaxed">{t("manufacturers_page.model_text")}</p>
        </div>
      </section>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <SectionHeader eyebrow="Case Studies" title={t("manufacturers_page.case_title")} align="center"/>
          <p className="mt-8 text-lg text-[#4A5568]">{t("manufacturers_page.case_placeholder")}</p>
          <Link to="/contact#partner" data-testid="mfg-cta" className="btn-primary mt-10 inline-flex">Request confidential briefing <ArrowRight size={16}/></Link>
        </div>
      </section>
    </div>
  );
}
